import React, { Fragment as F } from 'react'
import { connect } from 'react-redux'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'

import Loading from 'discada/dist/Loading'

import ContractBlock, {
  RetailPricing,
  LeasePricing,
  MonthlyPayment,
  VehicleBlock,
  VehicleImage,
  LeaseRebates,
  RetailTaxesAndFees,
  Signature,
  Equity,
  CashEquity,
  RetailBankBlock,
  LeaseTaxesAndFees,
  LeaseBankBlock,
  CCR,
  LeaseCash,
  CashWrapUpBlock,
} from 'components/ContractBlock'
import { DirtyButton, DirtyMask } from 'components/widgets/Dirty'
import ProgramDetails from 'components/Quote/ProgramDetails'
import { getIsLoading, getBestProgram } from 'selectors/quoteSelectors'

import './ContractDetails.scss'

export const CashContractDetails = props => {
  return (
    <F>
      {!props.hideHeader && (
        <F>
          <VehicleBlock {...props} width="full" />
          <VehicleImage {...props} width="half" />
          <MonthlyPayment {...props} mode="cash" width="half" />
        </F>
      )}
      <RetailPricing {...props} width="full" />
      <RetailTaxesAndFees {...props} width="half" />
      <CashEquity {...props} width="half" hideCash />
      <CashWrapUpBlock {...props} width="full" />
      <Signature {...props} width="full" />

      {!props.hideDisclaimer && (
        <ContractBlock width="full">
          <ProgramDetails {...props} />
        </ContractBlock>
      )}
    </F>
  )
}

export const LoanContractDetails = props => {
  return (
    <F>
      {!props.hideHeader && (
        <F>
          <VehicleBlock {...props} width="full" />
          <VehicleImage {...props} width="half" />
          <MonthlyPayment {...props} mode="loan" width="half" />
        </F>
      )}
      <RetailPricing {...props} width="full" />
      <RetailTaxesAndFees {...props} width="half" />
      <Equity {...props} width="half" />
      <RetailBankBlock {...props} width="full" />
      <Signature {...props} width="full" />
      {!props.hideDisclaimer && (
        <ContractBlock width="full">
          <ProgramDetails {...props} />
        </ContractBlock>
      )}
    </F>
  )
}

export const LeaseContractDetails = props => {
  return (
    <F>
      {!props.hideHeader && (
        <F>
          <VehicleBlock {...props} width="full" />
          <VehicleImage {...props} width="half" />
          <MonthlyPayment {...props} mode="lease" width="half" />
        </F>
      )}

      <LeasePricing {...props} width="full" />

      <LeaseCash {...props} width="auto" />
      <LeaseRebates {...props} width="half" />

      <CCR {...props} width="half" />
      <LeaseTaxesAndFees {...props} width="auto" />

      <LeaseBankBlock {...props} width="full" />
      <Signature {...props} width="full" />

      {!props.hideDisclaimer && (
        <ContractBlock width="full">
          <ProgramDetails {...props} />
        </ContractBlock>
      )}
    </F>
  )
}

export function ContractDetails(props) {
  let { vehicleId, quoteId, mode, programInfo, header, isLoading } = props,
    noShow = isEmpty(programInfo) || typeof programInfo === 'string'

  if (!isLoading && noShow) {
    return (
      <div className="program-info-error">
        We had a problem getting the Payment Summary for this program. Please
        try again.
        <DirtyButton {...props} size="small" />
      </div>
    )
  }

  let Comp = {
    loan: LoanContractDetails,
    lease: LeaseContractDetails,
    cash: CashContractDetails,
  }[mode]

  return (
    <div className="contract-details-wrapper">
      <DirtyMask vehicleId={vehicleId} quoteId={quoteId} />
      {isLoading ? (
        <Loading />
      ) : (
        <F>
          {header}
          <Comp {...props} />
        </F>
      )}
    </div>
  )
}

function mapStateToProps(state, op) {
  return {
    ...op,
    programInfo: get(
      getBestProgram(state, op.vehicleId, op.quoteId, op.mode),
      'programInfo',
    ),
    isLoading: getIsLoading(state, op.vehicleId, op.quoteId),
  }
}

export default connect(mapStateToProps)(ContractDetails)
